var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"groups"},[_c('h1',{staticClass:"mb-3"},[_vm._v("Список групп")]),_c('GroupsGrid')],1)}
var staticRenderFns = []

export { render, staticRenderFns }